export default "/images/vendor/flag-icon-css/flags/4x3/tw.svg?83324ef79fd96b77a6090612fad174df";